<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Transações Programadas</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 px-3>
          <v-flex xs12 md3 lg2 px-1>
            <DefaultFilterDate ref="filterStartDate" @reload="this.reloadStartDate" kind="date" label="Data inicial" />
          </v-flex>
          <v-flex xs12 md3 lg2 px-1>
            <DefaultFilterDate ref="filterEndDate" @reload="this.reloadEndDate" kind="date" label="Data final" />
          </v-flex>
          <v-flex xs12 md3 lg3 px-1>
            <CompanySelect
              :model="filterCompanyId"
              label="Parceiro"
              @onIdSelected="this.companyIdSelected"
              @onCompanyList="this.companyListSelected"
              ref="filterCompanyId"
            />
          </v-flex>
          <v-flex xs12 md3 lg3 px-1>
            <CompanySelect ref="filterSubjectId" :model="filterSubjectId" :label="i18n('Nº do Doc. Cliente')" search_mode="document_number_prefix" @onCompanyList="this.subjectListSelected" @onIdSelected="this.subjectIdSelected" />
          </v-flex>
          <v-flex xs6 md3 lg1 px-1>
            <v-select
              box
              clearable
              label="Moeda O."
              v-model="filterCurrencyFrom"
              @click:clear="filterCurrencyFrom = null"
              @change="filterCurrencyChanged()"
              :items="currencyFilterItems"
            ></v-select>
          </v-flex>
          <v-flex xs6 md3 lg1 px-1>
            <v-select
              box
              clearable
              label="Moeda D."
              v-model="filterCurrencyTo"
              @click:clear="filterCurrencyTo = null"
              @change="filterCurrencyChanged()"
              :items="currencyFilterItems"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3 lg2 px-2>
            <v-text-field
              v-model="filterId"
              box
              append-icon="manage_search"
              class="search-filter"
              placeholder="Pesquisar por ID"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md2 lg2 px-2>
            <v-text-field
              v-model="filterNSU"
              box
              append-icon="credit_card"
              class="search-filter"
              placeholder="Pesquisar por NSU"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md2 lg2 px-1>
            <v-select
              box
              clearable
              label="Liberação"
              append-icon="how_to_reg"
              v-model="filterCleared"
              :items="[{text: 'Liberadas', value: true}, {text: 'Não liberadas', value: false}]"
            ></v-select>
          </v-flex>
          <v-flex xs6 md2 lg2 px-1>
            <v-select
              box
              clearable
              label="Transação bancária"
              append-icon="account_balance"
              v-model="filterUnmatched"
              :items="[{text: 'Com transação', value: false}, {text: 'Sem transação', value: true}]"
            ></v-select>
          </v-flex>
          <v-flex xs6 md3 lg2 px-1>
            <v-select
              box
              clearable
              label="Canceladas"
              v-model="filterCanceled"
              append-icon="search_off"
              @click:clear="filterCanceled = null"
              :items="[{text: 'Canceladas', value: true}, {text: 'Não canceladas', value: false}]"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3 lg2>
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="filter()">
              Update
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <div v-if="bankTransactionsLoaded == 'not_loaded'">Carregando transações...</div>
          <div v-if="bankTransactionsLoaded == 'error'">Algo errado. Não foi possível carregar as transações.</div>
          <div v-if="bankTransactionsLoaded == 'not_authorized'">Não foi possível carregar as transações. Você não foi autorizado.</div>
          <div v-if="bankTransactionsLoaded == 'empty'">Não foram localizadas transações que satisfaçam o filtro aplicado.</div>
          <transition name="fade">
            <scheduled-bank-transaction-list class="mt-3" :config="bankTransactionsConfig" v-if="bankTransactionsLoaded == 'ok'" @loadMoreRecords="loadBankTransactions" />
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import ScheduledBankTransactionList from "./ScheduledBankTransactionList"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import CompanySelect from "./components/filters/CompanySelect"
import { getAllCurrenciesSelect } from "./shared/Currencies";
import utils from "./shared/Utils"

export default {
  name: 'AdminUnmatchedScheduledBankTransactionList',
  components: { layout: LeftBarLayout, 'scheduled-bank-transaction-list': ScheduledBankTransactionList, DefaultFilterDate, CompanySelect },
  data() {
    return {
      bankTransactionsConfig: {
        title: 'Transações Programadas Pendentes',
        records: [],
        loading: false,
        perPage: 100
      },
      filterId: null,
      filterNSU: null,
      filterStartDate: null,
      filterEndDate: null,
      filterCleared: null,
      filterCanceled: false,
      filterCompanyId: null,
      filterSubjectId: null,
      filterUnmatched: true,
      filterCurrencyTo: null,
      filterCurrencyFrom: null,
      filterCompanyList: [],
      filterSubjectList: [],
      consolidateFilter: {
        filterStartDate: null,
        filterEndDate: null,
        filterCompanyId: null,
        filterSubjectId: null,
        filterCompanyList: [],
        filterSubjectList: [],
        filterCurrencyTo: null,
        filterCurrencyFrom: null,
        filterId: null,
        filterNSU: null,
        filterCleared: null,
        filterUnmatched: true,
        filterCanceled: false
      },
      bankTransactionsLoaded: 'not_loaded',
      currencyFilterItems: getAllCurrenciesSelect(),
      targetUrl: this.$root.urls.admin__scheduled_bank_transactions
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadBankTransactions()
  },
  methods: {
    reloadStartDate(filter_date) {
      this.filterStartDate = filter_date
    },
    reloadEndDate(filter_date) {
      this.filterEndDate = filter_date
    },
    companyIdSelected(id) {
      this.filterCompanyId = id
    },
    subjectIdSelected(id) {
      this.filterSubjectId = id
    },
    companyListSelected(companyList) {
      this.filterCompanyList = companyList
    },
    subjectListSelected(subjectList) {
      this.filterSubjectList = subjectList
    },
    filterCurrencyChanged() {
    },
    filter() {
      this.consolidateFilter = {
        filterStartDate: this.filterStartDate,
        filterEndDate: this.filterEndDate,
        filterCompanyId: this.filterCompanyId,
        filterSubjectId: this.filterSubjectId,
        filterCompanyList: [...this.filterCompanyList],
        filterSubjectList: [...this.filterSubjectList],
        filterCurrencyTo: this.filterCurrencyTo,
        filterCurrencyFrom: this.filterCurrencyFrom,
        filterId: this.filterId,
        filterNSU: this.filterNSU,
        filterCleared: this.filterCleared,
        filterUnmatched: this.filterUnmatched,
        filterCanceled: this.filterCanceled
      };

      this.reloadRecords()
    },
    reloadRecords() {
      if (this.bankTransactionsConfig.loading) {
        this.bankTransactionsConfig.loading = true
      } else {
        this.bankTransactionsConfig.loading = false
        this.bankTransactionsConfig.records = []
        this.bankTransactionsLoaded = 'not_loaded'
        this.loadBankTransactions(null)
      }
    },
    resetFilter() {
      this.bankTransactionsConfig.records = []
      this.bankTransactionsLoaded = 'not_loaded'

      this.filterStartDate = null
      this.$refs.filterStartDate.filterDate = null

      this.filterEndDate = null
      this.$refs.filterEndDate.filterDate = null

      this.filterCompanyId = null
      this.$refs.filterCompanyId.search = null
      this.$refs.filterCompanyId.selectedCompanyId = null
      this.$refs.filterCompanyId.entries = []

      this.filterSubjectId = null
      this.$refs.filterSubjectId.search = null
      this.$refs.filterSubjectId.selectedCompanyId = null
      this.$refs.filterSubjectId.entries = []

      this.filterCurrencyFrom = null
      this.filterCurrencyTo = null
      this.filterId = null
      this.filterNSU = null
      this.filterCleared = null
      this.filterUnmatched = true
      this.filterCanceled = false

      this.consolidateFilter = {
        filterStartDate: null,
        filterEndDate: null,
        filterCompanyId: null,
        filterCompanyList: [],
        filterSubjectId: null,
        filterSubjectList: [],
        filterCurrencyTo: null,
        filterCurrencyFrom: null,
        filterId: null,
        filterNSU: null,
        filterCleared: null,
        filterUnmatched: true,
        filterCanceled: false
      }

      this.filterCompanyList = []
      this.filterSubjectList = []

      this.reloadRecords()
    },
    async loadBankTransactions(last_id) {
      if (this.bankTransactionsConfig.loading) return

      this.resetToConsolidateFilter()

      let successCallback = (response) => {
        if (response.body.data) {
          this.bankTransactionsConfig.records = this.bankTransactionsConfig.records.concat(...response.body.data)

          if (this.bankTransactionsConfig.records.length === 0) {
            this.bankTransactionsLoaded = 'empty'
          } else {
            this.bankTransactionsLoaded = 'ok'
          }
        } else {
          this.bankTransactionsLoaded = 'error'
          console.log('successCallback', response)
        }

        this.bankTransactionsConfig.loading = false
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.bankTransactionsLoaded = 'not_authorized'
        } else {
          this.bankTransactionsLoaded = 'error'
        }

        this.bankTransactionsConfig.loading = false
        console.log('errorCallback', response)
      }

      this.bankTransactionsConfig.loading = true
      let params = { per_page: this.bankTransactionsConfig.perPage }
      if (this.consolidateFilter.filterStartDate) { params.from = utils.filterDateFrom(this.consolidateFilter.filterStartDate, false).toISOString() }
      if (this.consolidateFilter.filterEndDate) { params.to = utils.filterDateTo(this.consolidateFilter.filterEndDate, false).toISOString() }

      const addFilterToParams = function(value, field, params) {
        value = typeof value === 'string' ? value.trim() : value

        if (value === null || value === '' || typeof(value) === 'undefined') { return params }
        params[field] = value
        return params
      }

      const filters = [
        { value: last_id, field: 'last_id' },
        { value: this.consolidateFilter.filterId, field: 'id' },
        { value: this.consolidateFilter.filterNSU, field: 'acquirer_nsu' },
        { value: this.consolidateFilter.filterCanceled, field: 'canceled' },
        { value: this.consolidateFilter.filterCleared, field: 'cleared_status' },
        { value: this.consolidateFilter.filterUnmatched, field: 'unmatched' },
        { value: this.consolidateFilter.filterCompanyId, field: 'company_id' },
        { value: this.consolidateFilter.filterSubjectId, field: 'subject_id' },
        { value: this.consolidateFilter.filterCurrencyFrom, field: 'currency' },
        { value: this.consolidateFilter.filterCurrencyTo, field: 'exchange_currency' }
      ]

      filters.forEach(filter => {
        params = addFilterToParams(filter.value, filter.field, params)
      })

      let token = this.$cookies.get('api_token')
      this.$http.get(this.targetUrl, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    resetToConsolidateFilter() {
      this.filterStartDate = this.consolidateFilter.filterStartDate;
      this.$refs.filterStartDate.filterDate = this.consolidateFilter.filterStartDate;

      this.filterEndDate = this.consolidateFilter.filterEndDate;
      this.$refs.filterEndDate.filterDate = this.consolidateFilter.filterEndDate;

      this.filterCompanyId = this.consolidateFilter.filterCompanyId
      this.filterCompanyList = [...this.consolidateFilter.filterCompanyList]
      this.$refs.filterCompanyId.entries = [...this.consolidateFilter.filterCompanyList]
      this.$refs.filterCompanyId.search = ''
      this.$refs.filterCompanyId.selectedCompanyId = this.consolidateFilter.filterCompanyId

      this.filterSubjectId = this.consolidateFilter.filterSubjectId;
      this.filterSubjectList = [...this.consolidateFilter.filterSubjectList]
      this.$refs.filterSubjectId.entries = [...this.consolidateFilter.filterSubjectList]
      this.$refs.filterSubjectId.search = ''
      this.$refs.filterSubjectId.selectedCompanyId = this.consolidateFilter.filterSubjectId

      this.filterCurrencyTo = this.consolidateFilter.filterCurrencyTo
      this.filterCurrencyFrom = this.consolidateFilter.filterCurrencyFrom
      this.filterId = this.consolidateFilter.filterId
      this.filterNSU = this.consolidateFilter.filterNSU
      this.filterCleared = this.consolidateFilter.filterCleared
      this.filterUnmatched = this.consolidateFilter.filterUnmatched
      this.filterCanceled = this.consolidateFilter.filterCanceled
    },
    i18n(str) {
      return this.$root.l(str)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AdminUnmatchedScheduledBankTransactionList.vue